import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const PrairieDividers = ({ value, onChange, id = 'PrairieDividers', label = 'Prairie Dividers', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedDivider, setSelectedDivider] = useState(defaultValue);

    const dividerOptions = [
        { id: 1, value: 'standard', label: 'Standard' },
        { id: 2, value: 'verticals_only', label: 'Verticals Only' },
        { id: 3, value: 'horizontals_only', label: 'Horizontals Only' },
    ];

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedDivider(value?.value || '');
    }, [value?.value]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (dividerOptions.length > 0 && !selectedDivider) {
            const defaultOption = dividerOptions[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedDivider(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, []);

    const handleDividerChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedDivider(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedDivider}
                onChange={handleDividerChange}
            >
                {dividerOptions.map(option => (
                    <option key={option.id} value={option.value}>
                        {selectedDivider === option.value ? `${option.label} ✔` : option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default PrairieDividers;
